import { useCallback } from 'react';
import { z } from 'zod';

const base64ImageSchema = z.string();

export const useGetBase64Image = () => {
  return useCallback((file: File) => {
    return new Promise((resolve: (base64: string) => void, reject: (reason: Error) => void) => {
      const reader = new FileReader();
      reader.onloadend = (e) => {
        const parsedResult = base64ImageSchema.safeParse(e.target?.result);
        if (parsedResult.success) {
          resolve(parsedResult.data);
        } else {
          reject(new Error('Error reading file'));
        }
      };
      reader.onerror = (e) => {
        reject(e.target?.error || new Error('Error reading file'));
      };
      reader.readAsDataURL(file);
    });
  }, []);
};
